<div class="modal-content">
  <div class="modal-header">
    <label class="modal-title text-text-bold-900" id="myModalLabel33"><b>Etiketi düzenle</b></label>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
 
    <div class="modal-body">

      <form [formGroup]="definitionForm">
        <div class="modal-body">
    
       
    
          <div class="form-group">
            <label>Kullanım Amacı</label>
            <textarea class="form-control" formControlName="usagePurpose" rows="5"></textarea>
          </div>
    
     <div class="form-group">
            <label>Kullanım Talimatı</label>
            <textarea class="form-control" formControlName="usageInstructions" rows="5"></textarea>
          </div>
    

              <div class="form-group">
                <label>Uyarılar <button class="btn btn-success" (click)="addWarning('')">+Ekle</button></label>

                          <div formArrayName="warnings"
                            *ngFor="let dep of getWarning().controls;let i=index">
                            <div class="row mt-1" [formGroupName]="i">
                              <div class="col-md-11">
                                <input type="text" class="form-control" formControlName="property" name="property"
                                  id="{{i}}property">
                              </div>
                             

                              <div class="col-md-1">
                                <i class="la la-trash danger cursor mt-1" (click)="removeWarning(i)">

                                </i>
                              </div>
                            </div>
                          </div>
                        </div>
          
          
        </div>
    
        <div class="modal-footer">
          <button type="reset" class="btn grey btn-outline-secondary"
            (click)="close()">Kapat</button>
          <button type="button" class="btn btn-success" (click)="save()" [disabled]="submitted">
            <i class="fa fa-refresh fa-spin" *ngIf="submitted"></i>
            Güncelle</button>
             <button type="button" class="btn btn-primary" (click)="saveall()" [disabled]="submitted">
            <i class="fa fa-refresh fa-spin" *ngIf="submitted"></i>
            Tüm eşdeğerleri güncelle</button>
        </div>
      </form>

</div>